<template>
  <div>
    <div class="d-flex justify-content-between align-items-center">
      <div class="section-title">{{ $t("emailtemplate") }}</div>
      <router-link
        v-if="$can('create', 'Email Template')"
        class="btn-blue"
        to="add-email-template"
        >{{ $t("add") }}</router-link
      >
    </div>
    <div class="d-flex justify-content-between align-items-center my-3">
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <div class>
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp;
              <strong>{{ rows }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              href="#"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>
    </div>

    <div>
      <table class="list-view-table">
        <thead>
          <tr>
            <th class="text-left" style="width: 120px;">
              <span class="pr-3">{{ $tc("status", 1) }}</span>
            </th>
            <th>
              <img
                v-if="this.columnName != 'et_description'"
                @click="onSortValue('et_description', 'asc')"
                src="@/assets/img/icons/updown.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else-if="isSort && isAscending"
                @click="onSortValue('et_description', 'asc')"
                src="@/assets/img/icons/asc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else
                @click="onSortValue('et_description', 'desc')"
                src="@/assets/img/icons/desc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              {{ $t("email") }} {{ $t("template") }} {{ $t("name") }}
            </th>
            <th></th>
          </tr>
        </thead>
        <tbody v-if="emailtemplateList && emailtemplateList.length > 0">
          <tr
            v-for="(emailtemplate, emailtemplateIndex) in emailtemplateList"
            :key="emailtemplateIndex"
          >
            <!-- <td>
              <div class="d-flex align-items-center justify-content-end">
                <StatusDot
                  :status="
                    emailtemplate.is_et_active === 'Y'
                      ? 'active'
                      : emailtemplate.is_et_active === 'N' && 'inactive'
                  "
                />
                <b-dropdown variant="edit" class="ml-4">
                  <b-dropdown-item
                    v-if="$can('update', 'Email Template')"
                    v-on:click="onEmailTemp('Edit', emailtemplate)"
                  >
                    <span class="edit-pen"></span>
                    {{ $t("edit") }}
                  </b-dropdown-item>

                  <b-dropdown-item
                    v-on:click="onEmailTemp('View', emailtemplate)"
                  >
                    <span class="icon-eye"></span>
                    {{ $t("view") }}
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </td> -->
            <td>
              <div class="d-flex align-items-center justify-content-start">
                <StatusDot
                  :status="
                    emailtemplate.is_et_active === 'Y'
                      ? 'active'
                      : emailtemplate.is_et_active === 'N' && 'inactive'
                  "
                />

                <i
                  v-if="$can('update', 'Email Template')"
                  class="edit-pen icon blue-icon cursor-pointer ml-4"
                  @click="onEmailTemp('Edit', emailtemplate)"
                  v-b-tooltip="'Edit'"
                  tabindex="0"
                ></i>

                <i
                  class="icon-eye blue-icon cursor-pointer ml-2"
                  @click="onEmailTemp('View', emailtemplate)"
                  v-b-tooltip="'View'"
                  tabindex="0"
                ></i>
              </div>
            </td>

            <td>{{ emailtemplate.et_description }}</td>
            <td class="text-center">
              <b-button
                variant="default"
                class="btn-blue"
                @click.prevent.stop="OpenModal(emailtemplate)"
                >Test</b-button
              >
            </td>
          </tr>
        </tbody>

        <tbody v-else>
          <tr>
            <td colspan="3">
              <NoRecords />
            </td>
          </tr>
        </tbody>
      </table>
      <b-pagination
        v-model="currentPage"
        :total-rows="rows"
        @change="onChangePagination($event)"
        :per-page="perPage"
        aria-controls="my-table"
      ></b-pagination>
    </div>

    <b-modal
      id="emailtest"
      class="modal-content"
      hide-header
      hide-footer
      no-close-on-backdrop
    >
      <div
        class="modal-header w-100 d-flex align-items-start mb-3 pt-0 pl-0 pr-0"
      >
        <label class="w-75 h4">Send Email</label>
        <button
          type="button"
          class="close w-25 btn-clearDate text-right"
          v-on:click="hideModal('emailtest')"
        >
          ×
        </button>
      </div>
      <div class="modal-body">
        <div class="input-material">
          <input
            v-model="toemail"
            v-validate="'required|email'"
            placeholder="."
            type="text"
            name="toemail"
            id="toemail"
          />
          <label :class="toemail.length > 0 ? 'shift-up' : ''">{{
            $t("to")
          }}</label>
        </div>
        <p v-if="submitted && errors.has('toemail')" class="error_message">
          <span>{{ errors.first("toemail") }}</span>
        </p>

        <br />
        <div class="w-100 text-center">
          <button
            :disabled="btenable"
            class="btn-blue text-center"
            @click.prevent.stop="SendEmail()"
          >
            Send
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
    NoRecords,
  },
  data() {
    return {
      btenable: false,
      submitted: false,
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      viewingnumbers: [],
      emailtemplateList: [],
      toemail: "",
      tempdetails: [],
      //Sorting data
      isSort: false,
      isAscending: true,
      orderby: "",
      columnName: "",
    };
  },
  beforeMount() {
    this.getEmailTemplateList();
    this.getviewingnumber();
  },
  methods: {
    getviewingnumber: function () {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },
    /* eslint-disable */
    onChangePagination: function (event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.getEmailTemplateList();
      } else {
        this.currentPage = event;
        this.getEmailTemplateList();
      }
    },

    onEmailTemp: function (type, data) {
      if (type == "Edit") {
        this.$router.push({
          path: "/master/edit-email-template",
          query: { et_id: data.et_id },
        });
      } else {
        this.$router.push({
          path: "/master/view-email-template",
          query: { et_id: data.et_id },
        });
      }
    },

    OpenModal: function (data) {
      this.tempdetails = data;
      this.$bvModal.show("emailtest");
    },
    hideModal: function (modal) {
      if (modal == "emailtest") {
        this.toemail = "";
        this.btenable = false;
        this.$bvModal.hide("emailtest");
      }
    },

    SendEmail: function () {
      this.submitted = true;

      this.$validator.validate().then((valid) => {
        if (valid) {
          let loader = this.$loading.show();
          this.btenable = true;

          let payload = {
            to: this.toemail,
            templateDetails: this.tempdetails,
          };

          MasterService.Sendemail(payload)
            .then((response) => {
              this.btenable = false;
              const { data } = response;

              if (data && data.status) {
                this.submitted = false;
                this.toemail = "";
                this.$bvModal.hide("emailtest");
                this.$toasted.show(data.message);
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError)
            .finally(() => {
              setTimeout(() => loader.hide(), 1000);
            });
        }
      });
    },
    //Sort
    onSortValue(columnName, orderby) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderby = orderby;
      this.getEmailTemplateList();
    },

    getEmailTemplateList: function () {
      let body = {
        limit: this.perPage,
        currentPage: this.currentPage,
        columnName: this.columnName,
        orderBy: this.orderby,
      };
      MasterService.GetEmailTemplate(body)
        .then((response) => {
          const { data } = response;

          if (data && data.status) {
            if (data.Records && data.Records.length > 0) {
              this.emailtemplateList = data.Records;

              if (data.totalRows >= 10) {
                this.rows = data.totalRows;
              } else {
                this.rows = data.totalRows;
                this.selectedvalue = data.totalRows;
              }
            }
          }
        })
        .catch(this._CatchError);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/EmailTemplateComponents/listemailtemplate.vue